import {
    SET_IS_TESTING_ENV,
    SET_IS_DEV_ENV,
    SET_IS_LOCALHOST_ENV,
    SET_IS_EMEX,
    SET_IS_MOBILE,
    SET_IS_BIG_TABLET,
} from '../actions/environment';

export const environmentInitialState = {
    isTestingEnv: window.location.href.includes('test'),
    isLocalhostEnv: window.location.href.includes('localhost'),
    isDevEnv: window.location.href.includes('dev'),
    isEmex: window.location.pathname.includes('/emex'),
    isMobile: window.innerWidth < 1024,
    isBigTablet: window.innerWidth >= 1024,
};

export default (state = environmentInitialState, { type, result, payload }) => {
    switch (type) {
        case SET_IS_TESTING_ENV:
            return { ...state, isTestingEnv: true };

        case SET_IS_DEV_ENV:
          return { ...state, isDevEnv: true };

        case SET_IS_LOCALHOST_ENV:
          return { ...state, isLocalhostEnv: true };

        case SET_IS_EMEX:
            return { ...state, isEmex: true };

        case SET_IS_MOBILE:
            return { ...state, isMobile: payload };

        case SET_IS_BIG_TABLET:
            return { ...state, isBigTablet: payload };

        default:
            return state;
    }
};
